/*
    Ruta de la api de catalogo
*/
export default {
    APP_CATALOGOS: '/api/Catalogos',
     URL_MESES : '/api/MesMinistracion/MesActivo',


}